/* eslint-disable no-console */
import { useEffect, useState } from 'react';

import { env } from '@/env/env';

export const useMockServiceWorker = () => {
  const [isReady, setIsReady] = useState(!env.VITE_MOCK_MODE);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    if (!env.VITE_MOCK_MODE) {
      return;
    }
    async function initMSW() {
      try {
        const { worker } = await import('@/mocks/browser');

        await worker.start({
          onUnhandledRequest: 'warn',
          quiet: false,
          serviceWorker: {
            url: '/mockServiceWorker.js'
          }
        });

        console.log('🔶 Mock mode enabled - MSW intercepting API requests');
        setIsReady(true);
      } catch (err) {
        const error = err instanceof Error ? err : new Error('Failed to start MSW');
        console.error('❌ Failed to start MSW:', error);
        setError(error);
        setIsReady(true);
      }
    }

    void initMSW();
  }, []);

  return { isReady, error };
};
